import { render, staticRenderFns } from "./agreementChildrenPrivacy.vue?vue&type=template&id=1f44c50c&scoped=true"
import script from "./agreementChildrenPrivacy.vue?vue&type=script&lang=js"
export * from "./agreementChildrenPrivacy.vue?vue&type=script&lang=js"
import style0 from "./agreementChildrenPrivacy.vue?vue&type=style&index=0&id=1f44c50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f44c50c",
  null
  
)

export default component.exports